<template>
  <div class="container_self">
    <el-row class="table_parent">
      <h3>小说分类列表</h3>
      <el-row class="add_btn"><el-button type="success" icon="el-icon-plus" size="mini" @click="addCategory">添加分类</el-button></el-row>

      <el-table :data="list" v-loading="loading">
        <el-table-column label="ID" prop="id" align="center" width="50"></el-table-column>
        <el-table-column label="分类名称" prop="name" align="center"></el-table-column>
        <!-- <el-table-column label="父分类ID" prop="parentId" align="center"></el-table-column> -->
        <el-table-column label="排序" prop="sorted" align="center"></el-table-column>
        <el-table-column label="操作" fixed="right" align="center">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" @click="updateCategory(scope.row)"
              >更新</el-button
            >
            <el-button type="danger" size="mini" @click="deleteCategory(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <el-dialog
        :title="string + '分类'"
        :visible.sync="dialogFormVisible"
        label-width="120px"
      >
        <el-form :model="addCategoryForm" label-width="120px" size="mini" class="demo-ruleForm">
          <el-form-item label="分类名称">
            <el-input
              v-model="addCategoryForm.name"
              placeholder="请输入分类名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="排序ID">
            <el-input v-model="addCategoryForm.sorted" autocomplete="off"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="submitForm">确 定</el-button>
        </div>
      </el-dialog>
    </el-row>
  </div>
</template>

<script>
import { axiosGet, axiosPost } from "@/assets/ajaxFn";
export default {
  data() {
    return {
      list: [],
      dialogFormVisible: false,
      string: "添加",
      addCategoryForm: {
        name: "",
        parentId: 0,
        sorted: "",
      },
      edit: false,
      loading: true,
    };
  },
  methods: {
    submitForm() {
      if (!this.addCategoryForm.name || !this.addCategoryForm.sorted) {
        this.$message({ message: "所有选项不能为空", type: "warning" });
        return false;
      }
      let url = this.edit ? "/api/movie/category/update" : "/api/movie/category/add";
      axiosPost(url, this.addCategoryForm, "JSON").then((res) => {
        if (res.code == 0) {
          this.$message({ message: "分类"+this.string+"成功", type: "success" });
          this.dialogFormVisible = false;
          this.getCategoryList();
        }
      });
    },
    addCategory() {
      this.addCategoryForm = {
        name: "",
        parentId: "",
        sorted: "",
      };
      this.edit = false;
      this.string = "添加";
      this.dialogFormVisible = true;
    },
    getCategoryList() {
      this.loading = true;
      axiosGet("/api/movie/category/list").then((res) => {
        if (res.code == 0) {
          if (res.data) {
            this.list = res.data;
          }

          this.loading = false;
        }
      });
    },
    updateCategory(row) {
      this.edit = true;
      this.string = "更新";
      this.addCategoryForm.id = row.id;
      this.addCategoryForm.name = row.name;
      this.addCategoryForm.parentId = row.parentId;
      this.addCategoryForm.sorted = row.sorted;
      this.dialogFormVisible = true;
    },
    deleteCategory(row) {
      this.$confirm("是否要删除 " + row.name + " 分类?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          axiosPost("/api/movie/category/delete", { id: row.id }, "JSON").then((res) => {
            if (res.code == 0) {
              this.getCategoryList();
              this.$message({ message: "删除成功", type: "success" });
            }
          });
        })
        .catch(() => {});
    },
  },
  mounted() {
    this.getCategoryList();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/view/novelManager/categoryList.vue